
import Brands from '@/graphql/queries/taxonomy/Brands'
import { nthChild } from 'vessel/utils'

export default {
  vessel: {
    icon: {
      pointerEvents: 'auto',
      color: 'primary',
      padding: 'xs',
      fontSize: '2xl',
      backgroundColor: 'white',
      borderRadius: 'full',
      cursor: 'pointer',
      shadow: true
    }
  },
  async fetch() {
    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: Brands
    })

    this.brands = data.brands
  },
  data() {
    return {
      brands: null
    }
  },
  methods: {
    detailsLink({ slug }) {
      const route = `brands/${slug}`
      return this.$pagePath(route)
    },
    logoClass(index) {
      const background = nthChild((index + 1), '2n') && this.$screen.lg
        ? 'grey-lightest'
        : 'white'

      const classes = this.$vessel.apply({
        backgroundColor: background
      })

      return classes
    }
  }
}
